import { IOrderCountPerStatus } from 'my-poppies-b2b-types';

import { getMultipliedOrders } from '@/api/mockApiCallForOrders';

export const dummyDataOrderCountPerStatus: IOrderCountPerStatus = {
  ALL_ORDERS: getMultipliedOrders('ALL_ORDERS').length,
  ALL_OPEN_ORDERS: getMultipliedOrders('ALL_OPEN_ORDERS').length,
  NEW: getMultipliedOrders('NEW').length,
  DECLINED: getMultipliedOrders('DECLINED').length,
  BEING_PREPARED: getMultipliedOrders('BEING_PREPARED').length,
  SHIPPED: getMultipliedOrders('SHIPPED').length,
  DELIVERED: getMultipliedOrders('DELIVERED').length,
  INTERNAL_ORDER_COMPLETED: getMultipliedOrders('INTERNAL_ORDER_COMPLETED').length,
  FLAWED: getMultipliedOrders('FLAWED').length,
  ALL_PREORDERS: getMultipliedOrders('ALL_PREORDERS').length,
  ALL_OPEN_PREORDERS: getMultipliedOrders('ALL_OPEN_PREORDERS').length,
  PREORDER: getMultipliedOrders('PREORDER').length,
  PREORDER_COMPLETED: getMultipliedOrders('PREORDER_COMPLETED').length,
};
